/**
 * HTML Sanitization utility using DOMPurify
 * Prevents XSS attacks when rendering user/server-provided HTML via dangerouslySetInnerHTML
 */
import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML string, removing dangerous tags/attributes (script, onerror, etc.)
 * while preserving safe formatting tags used in announcements and templates.
 *
 * @param {string} dirty - Untrusted HTML string
 * @returns {{ __html: string }} - Object ready for dangerouslySetInnerHTML
 */
export const sanitizeHtml = (dirty) => {
  return { __html: DOMPurify.sanitize(dirty || '') };
};
